import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
import utils from '@/util/utils.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/list", params, successCallback, failCallback, exceptionCallback);
	},
	tiyanlist: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/tiyanlist", params, successCallback, failCallback, exceptionCallback);
	},
	list2: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/list2", params, successCallback, failCallback, exceptionCallback);
	},
	list3: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/list3", params, successCallback, failCallback, exceptionCallback);
	},
	intionlist: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/intionlist", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/exams/exampaper/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},
	toVerify: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/toVerify", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/exams/exampaper/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/exams/exampaper/remove", params, successCallback, failCallback, exceptionCallback);
	},

	listQuesExamp: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/quesExamp/list", params, successCallback, failCallback, exceptionCallback);
	},
	listQuestion: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/quesExamp/listQuestion", params, successCallback, failCallback, exceptionCallback);
	},
	updateExamr: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/exams/quesExamp/updateExamr", params, successCallback, failCallback, exceptionCallback);
	},
	saveExamsandPaper: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/exams/exampaper/saveOffline", params, successCallback, failCallback, exceptionCallback);
	}, listWithCourse: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/listWithCourse", params, successCallback, failCallback, exceptionCallback);
	},
	//获取自动安排的试卷信息
	getAutoPaperInfo: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/getNextPaper", params, successCallback, failCallback, exceptionCallback);
	},
	getPapersByModule: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/getPapersByModule", params, successCallback, failCallback, exceptionCallback);
	},
	updateSubjectPapers: (params, successCallback, failCallback, exceptionCallback) => {
		 
		ApiUtils.postLoadingAjax(constant.serverUrl + "/edu/subject/updateSubjectPapers", params, successCallback, failCallback, exceptionCallback);
	},
	listByOrder: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/exams/exampaper/listByOrder", params, successCallback, failCallback, exceptionCallback);
	}
	 
}

export default api;